import React, { useState } from "react";
import { Plus, RefreshCw, ClipboardList } from "lucide-react";
import { Breadcrumb, GradientPanel, SearchInput, EmptyState, PrimaryButton } from "../components/common";
import { parseStatuses } from "../mock";

const Parse = () => {
  const [q, setQ] = useState("");
  const [active, setActive] = useState(null);
  return (
    <div>
      <Breadcrumb items={[{ label: "Dashboard", path: "/a/dashboard" }, { label: "Parse" }]} />
      <GradientPanel>
        <h1 className="text-2xl font-bold text-gray-900">Parse</h1>
        <p className="text-sm text-gray-500 mt-1">View and manage document parsing jobs.</p>

        <div className="flex flex-wrap items-center gap-2 mt-5">
          <PrimaryButton icon={Plus}>New</PrimaryButton>
          <button className="inline-flex items-center gap-2 text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-lg transition">
            <RefreshCw size={15} /> Refresh
          </button>
          {parseStatuses.map((s) => (
            <button
              key={s.id}
              onClick={() => setActive(active === s.id ? null : s.id)}
              className={`inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-lg border transition ${active === s.id ? "border-blue-400 bg-blue-50 text-blue-700" : "border-gray-200 text-gray-600 hover:border-gray-300"}`}
            >
              {s.label}
              <span className="text-xs bg-gray-100 text-gray-500 rounded px-1.5">{s.count}</span>
            </button>
          ))}
          <div className="ml-auto"><SearchInput value={q} onChange={(e) => setQ(e.target.value)} className="w-60" /></div>
        </div>

        <div className="mt-4 border-t border-gray-100">
          <EmptyState
            icon={ClipboardList}
            title="No parse jobs yet"
            desc="Parse jobs turn uploaded documents into structured data your team can review and action."
            action={<PrimaryButton icon={Plus}>Create parse job</PrimaryButton>}
          />
        </div>
      </GradientPanel>
    </div>
  );
};

export default Parse;
